// Layout-Wechsel Script für die Collection-Ansicht
document.addEventListener('DOMContentLoaded', function() {
  // Alle Radio-Buttons mit dem Namen "layout_alternativ" auswählen
  const radioButtons = document.querySelectorAll('input[name="layout_alternativ"]');
  
  // Das custom-pagination Element auswählen, dessen data-collection Attribut geändert werden soll
  const productGrid = document.querySelector('custom-pagination.main-products-grid');
  
  // Event-Listener für jeden Radio-Button hinzufügen
  radioButtons.forEach(function(radioButton) {
    radioButton.addEventListener('change', function(event) {
      // Den Wert des ausgewählten Radio-Buttons erfassen (grid oder list)
      const selectedLayout = event.target.value;
      
      // Nur das data-collection Attribut des Grids aktualisieren
      if (productGrid) {
        productGrid.setAttribute('data-collection', selectedLayout);
      }
      
      console.log('Layout geändert zu:', selectedLayout);
    });
  });
});